import { NgModule } from '@angular/core';
import {CommonModule} from '@angular/common';
import { NotificationPopupComponent } from './notification-popup.component';
import { TruncatePipeModule } from '../../pipes/truncate.pipe';
import { TranslateModule } from '../../../core/translate/translate.module';

@NgModule({
  declarations: [
    NotificationPopupComponent
  ],
  imports: [
    CommonModule,
    TruncatePipeModule,
    TranslateModule,
  ],
  exports: [
    NotificationPopupComponent
  ]
})
export class NotificationPopupModule { }
